// extracted by mini-css-extract-plugin
export var addressInformationBubbleContainer = "_mc-0";
export var buttonContainer = "_mc-3";
export var cancelButton = "_mc-4";
export var headerSection = "_mc-6";
export var headerTitle = "_mc-9";
export var messageSideLeft = "_mc-1";
export var messageSideRight = "_mc-2";
export var orderNumberContainer = "_mc-7";
export var orderNumberLabel = "_mc-8";
export var submitButton = "_mc-5";